
"use client";
import { useEffect } from "react";
export default function RecaptchaLoader({ siteKey }:{siteKey:string}) {
    useEffect(() => {
        if (!siteKey) {
            console.warn("[reCAPTCHA] siteKey vide dans RecaptchaLoader");
            return;
        }
        if (document.querySelector('script[data-recaptcha="true"]')) return;
        const s = document.createElement("script");
        s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
        s.async = true; s.defer = true;
        s.setAttribute("data-recaptcha", "true");
        document.head.appendChild(s);
    }, [siteKey]);
    return null;
}
